import dayjs from "dayjs"
import { addDoc, collection, doc, getDoc, setDoc, updateDoc } from "firebase/firestore"
import { auth, db } from "../firebase"

export const makeAppointment = async (info, otherUser) => {

    try {

        const user = (await getDoc(doc(db, "clients", auth.currentUser.uid))).data()
        const date = dayjs(info.DOA).format("YYYY-MM-DD")
        const queue = (await getDoc(doc(db, "queue", date))).data()

        let appointment = {
            info,
            DOA: date,
            otherUser,
            queuedAt: (queue?.line || 0) + 1,
            user: {
                ...user,
                uid: auth.currentUser.uid
            }
        }
 

        await addDoc(collection(db, "appointments"), appointment)
        await updateDoc(doc(db, "clients", auth.currentUser.uid), {
            ...info
        })
        await setDoc(doc(db, "queue", date), {
            queueAt: (queue?.queueAt || 1) , 
            line: (queue?.line || 0) + 1 
        })

        return null

    } catch(err) {

        console.log(err)
        return err.message
        
    }

}